<template>
    <div class="flex input_box">
        <div class="title_box">
            <p class="title"><span></span>限时发布</p>
        </div>
        <el-date-picker @change="get_time" :picker-options="pickerOptions" value-format="timestamp" v-model="time"
            type="datetime" placeholder="选择日期时间">
        </el-date-picker>
        <p style="width: 100%;padding:10px 0 0 120px; color: rgba(255, 0, 0, 1);">限定时间内发布，会降低出稿率，请谨慎使用！</p>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    computed: {
        ...mapState(['FillForm'])
    },
    mounted() {
        if (this.FillForm.limit_time) {
            this.time = this.FillForm.limit_time
        }
    },
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                },
            },
            time: '',

        }
    },
    methods: {
        get_time() {
            // if (!this.time) {
            //     this.time = new Date()
            // }
            // this.parseTime(new Date())
            this.$emit('get_timer', new Date(this.time).getTime())
            console.log(new Date(this.time).getTime());
        },
    },
}
</script>

<style lang=scss scoped>
@use '@/scss/Fill';

::v-deep .el-button--text {
    display: none !important;
}
</style>